// /chatbot-settings — the route element; the page is ChatbotSettings.
import React from 'react';
import ChatbotSettings from './ChatbotSettings';

const ChatbotSettingsPage = () => <ChatbotSettings />;

export default ChatbotSettingsPage;
